// extracted by mini-css-extract-plugin
export default {"routeName":"route-row_routeName__XYaZa"};